/**
 * Shared fuzzy search utility wrapping fuse.js.
 * Used by both the web UI (client-side sidebar filter) and the server (fuzzy task search).
 */
import Fuse from "fuse.js";
/**
 * Perform a fuzzy search over a collection of items.
 *
 * @param items - The items to search through.
 * @param query - The search query string. Empty string returns an empty array.
 * @param keys - Which fields to search, with relative weights.
 * @param options - Optional threshold and limit overrides.
 * @returns Matched items sorted by relevance (best first), capped at `limit`.
 */
export function fuzzySearch(items, query, keys, options) {
    if (!query.trim()) {
        return [];
    }
    const threshold = options?.threshold ?? 0.3;
    const fuse = new Fuse(items, {
        keys,
        threshold,
        ignoreLocation: true,
        includeScore: true,
        includeMatches: true,
        minMatchCharLength: 2,
    });
    const results = fuse.search(query);
    const mapped = results.map((r) => ({
        item: r.item,
        score: r.score ?? 1,
        matches: (r.matches ?? []).map((m) => ({
            key: m.key ?? "",
            indices: m.indices,
        })),
    }));
    if (options?.limit !== undefined) {
        return mapped.slice(0, options.limit);
    }
    return mapped;
}
//# sourceMappingURL=search.js.map